import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ApiPartnerService } from "@app/api/api-partner.service";
import swal from "sweetalert/dist/sweetalert.min.js";

@Component({
  selector: "master-channel",
  templateUrl: "./master-channel.component.html",
  styleUrls: ["./master-channel.component.css"],
})
export class MasterChannelComponent implements OnInit {

  @ViewChild("closeBtn", { static: false }) closeBtn: ElementRef;

  listChannels: any[] = [];
  table_load = true;

  paging: any = {};
  page_self: any = [];
  page_next: any = [];
  page_prev: any = [];
  meta: any = [];

  last_index: number;
  first_index: number;
  total_count: number;

  querySearch = false;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";

  limit = 10;
  msearch: string;
  textSearch = new FormControl("");

  alert_act: "add" | "view";
  message: string;
  itemset: any = {};

  formSet = this.fb.group({
    name: [""],
    logo: [""],
    streamUrl: [""],
    flagActive: ["1"],
  });

  selectedLogo: string | ArrayBuffer | null = null;
  selectedLogoFile: File = null;

  constructor(
    public partnerService: ApiPartnerService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loadStart();
  }

  /* ===================== UTIL ===================== */

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }

  alertsx(message: string) {
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(() => {
      this.closeModal();
      this.loadStart();
    }, 800);
  }

  alertfx(message: string) {
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
  }

  trackByFn(index: number): number {
    return index;
  }

  /* ===================== LOAD & SEARCH ===================== */

  loadStart() {
    this.route.queryParams.subscribe((params) => {
      this.currentParams = params;
      this.queryParams = "?" + this.queryStr(params);
      this.loadChannels(this.queryParams);
    });
    this.msearch = undefined;
  }

  refreshPage() {
    this.ngOnInit();
  }

  search() {
    this.querySearch = true;

    if (this.msearch === undefined) {
      this.msearch = "";
    }

    this.searchQueryParams =
      "?page=" +
      this.page_self.page +
      "&search=" +
      this.msearch +
      "&limit=" +
      this.limit;

    this.loadChannels(this.searchQueryParams);
  }

  loadChannels(params: any) {
    this.table_load = true;

    this.partnerService.GetChannels(params).subscribe((output: any) => {
      this.listChannels = output.data;
      this.table_load = false;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;

      this.total_count = this.meta.totalCount;
      const self = this.page_self.page;

      this.last_index =
        self * this.meta.perPage < this.meta.totalCount
          ? self * this.meta.perPage
          : this.meta.totalCount;

      this.first_index = (self - 1) * this.meta.perPage + 1;
    });
  }

  /* ===================== ACTION ===================== */

  onActionClick(act: "add" | "view", item: any = null) {
    this.alert_act = act;

    if (act === "add") {
      this.clearForm();
    }

    if (act === "view" && item) {
      this.itemset = item;
      this.clearForm();
      this.loadChannelDetail(item.id);
    }
  }

  clearForm() {
    this.formSet.reset();
    this.formSet.get("flagActive").setValue("1");
    this.selectedLogo = null;
    this.selectedLogoFile = null;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        this.selectedLogo = reader.result;
        this.selectedLogoFile = file;
        this.formSet.get("logoFile").setValue(file);
      };

      reader.readAsDataURL(file);
    }
  }

  loadChannelDetail(id: number) {
    this.partnerService.GetChannelDetail(id).subscribe((output: any) => {
      const data = output.data;
      this.formSet.patchValue({
        name: data.name,
        logo: data.logo,
        streamUrl: data.stream_url,
        flagActive: data.flag_active.toString(),
      });
    });
  }

  /* ===================== SUBMIT ===================== */

  submitAdd() {
    const payload = {
      name: this.formSet.get("name").value,
      logo: this.formSet.get("logo").value,
      stream_url: this.formSet.get("streamUrl").value,
    };

    this.partnerService.CreateChannel(payload).subscribe((output: any) => {
      if (output && output.status === true) {
        this.alertsx(output.message);
      } else {
        this.alertfx(output && output.message ? output.message : "Error hit API");
      }
    });
  }

  submitSet() {
    const id = this.itemset.id;

    const payload = {
      name: this.formSet.get("name").value,
      logo: this.formSet.get("logo").value,
      stream_url: this.formSet.get("streamUrl").value,
      flag_active: 1,
    };

    this.partnerService.UpdateChannel(id, payload).subscribe((output: any) => {
      if (output && output.status === true) {
        this.alertsx(output.message);
      } else {
        this.alertfx(output && output.message ? output.message : "Error hit API");
      }
    });
  }

  submitDelete() {
    const id = this.itemset.id;

    swal({
      title: "Are you sure?",
      text: `"${this.itemset.name}" akan dihapus`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.partnerService.DeleteChannel(id).subscribe((output: any) => {
          if (output && output.status === true) {
            this.alertsx(output.message);
          } else {
            this.alertfx(output && output.message ? output.message : "Error hit API");
          }
        });
      }
    });
  }
}